import { useEffect } from "react";
import { useDispatch } from "react-redux";
import queryString from "query-string";
import { config } from "node-config-ts";
import { LocaleTypes } from "@iddataweb/idw-common-ui/enums";
import { setQueryParameters } from "../redux/actions/query-parameters-actions";
import { useLocation, useSearchParams } from 'react-router-dom';
import { Logger } from "@utils/logger";
import { Environments } from "@enums/environment-types";

export const useQueryParameters = () => {
    const dispatch = useDispatch();
    const [searchParams, setSearchParams] = useSearchParams();
    const location = useLocation();

    const getQueryParameters = () => {
        const query = location.search || window.location.search;
        const queryParameters = queryString.parse(query, { decode: true });
        const pathName = location.pathname || window.location.pathname;
        Logger.info(`[App] Launching the DCUI App from query: ${query}`);
        Logger.info(`[App] Parsed Query params: ${JSON.stringify(queryParameters || {})}`, queryParameters);
        Logger.info(`Current path: ${pathName}`);
        let token = queryParameters.token;
        let apiUrl = queryParameters.apiUrl;
        let environment = queryParameters.e;

        if (!token) {
            token = queryParameters.t;
            apiUrl = config.API_HOSTNAME;
        }

        if (config.REACT_APP_USE_MOCK_AXN) {
            token = "xxxx-dev-xxx-xxxxx-token";
            environment = Environments.LOCAL;
            apiUrl = config.REACT_APP_MOCK_AXN_URL;
        }

        return {
            ...queryParameters,
            token,
            environment: environment || config.APPLICATION_ENVIRONMENT,
            apiUrl,
            language: queryParameters.language
        };
    };

    useEffect(() => {
        const queryParameters = getQueryParameters();

        dispatch(setQueryParameters({
            token: queryParameters.token as string,
            environment: queryParameters.environment as string,
            apiUrl: queryParameters.apiUrl as string,
            language: queryParameters.language as LocaleTypes,
            initialized: true
        }));

        Object.keys(queryParameters).forEach(key => {
            if (searchParams.has(key)) {
                searchParams.delete(key);
            }
        })
        setSearchParams(searchParams);
    }, []);
};